import { Occasion } from '@moonpig/web-explore-types-graphql'
import { useFindLocaleText } from '../../text-localisation'
import { getLabelFromOccasion } from './ocassionMap'
import { PromptReminder } from './types'

/**
 * Hook to format the reminder prompt title based on the occasion type.
 *
 * For Birthday, Anniversary, and Wedding:
 *   "Shopping for [First name Last name]'s [occasion]?"
 *   "Aan het winkelen voor [name]'s [occasion]?"
 *
 * For all other occasions:
 *   "Shopping for [occasion] for [First name Last name]?"
 *   "Aan het winkelen voor [occasion] voor [name]?"
 */

const POSSESSIVE_OCCASIONS = [
  Occasion.BIRTHDAY,
  Occasion.ANNIVERSARY,
  Occasion.WEDDING,
]

const POSSESSIVE_KEY = 'find.reminder_prompt_title_possessive'
const DEFAULT_KEY = 'find.reminder_prompt_title_default'

export const useFormatReminderTitle = (reminder: PromptReminder): string => {
  const localiseText = useFindLocaleText()
  const occasionLabel = getLabelFromOccasion(reminder.occasion)

  const isPossessiveKey = POSSESSIVE_OCCASIONS.includes(
    reminder.occasion as Occasion,
  )

  const localiseKey = isPossessiveKey ? POSSESSIVE_KEY : DEFAULT_KEY

  return localiseText(
    localiseKey,
    { name: reminder.name },
    { occasion: occasionLabel },
  )
}
